import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class IsNumericTextBox extends React.Component<NumericTextBoxProps, any>{
    private _numericRef: any;
    private _numeric: kendo.ui.NumericTextBox = null;
    private _value: any;
    private _disabled = true;
    private _min = null;
    private _max = null;
    private _icuh = Helper;

    constructor(props: NumericTextBoxProps) {
        super(props)
        this._checkAndSetMinAndMax(props);
    }

    private _checkAndSetMinAndMax = (props: NumericTextBoxProps) => {
        let tmpMin = null, tmpMax = null;

        if (this._icuh.hasValue(props.field.min) && this._icuh.isNumber(props.field.min)) {
            tmpMin = props.field.min;
        } else {
            tmpMin = null;
        }
        if (this._min !== tmpMin) {
            this._min = tmpMin;
            if (this._icuh.hasValue(this._numeric)) {
                this._numeric.min(this._min);
            }
        }

        if (this._icuh.hasValue(props.field.max) && this._icuh.isNumber(props.field.max)) {
            tmpMax = props.field.max;
        } else {
            tmpMax = null;
        }
        if (this._max !== tmpMax) {
            this._max = tmpMax;
            if (this._icuh.hasValue(this._numeric)) {
                this._numeric.max(this._max);
            }
        }
    }

    private _checkIfValueIsValid = (value: any): { valid: boolean; setToMin?: boolean; setToMax?: boolean; } => {
        const result: { valid: boolean; setToMin?: boolean; setToMax?: boolean; } = {
            valid: true,
            setToMin: false,
            setToMax: false
        }

        if (this._icuh.hasValue(value)) {
            if (this._min !== null && value < this._min) {
                result.valid = false;
                result.setToMin = true;
            }
            if (this._max !== null && value > this._max) {
                result.valid = false;
                result.setToMax = true;
            }
        }

        return result;
    }


    componentWillUnmount() {
        this._numeric.destroy();
    }

    componentDidMount() {
        this._disabled = this.props.disabled || false;
        this._value = this.props.value;
        this._numeric = $(this._numericRef).kendoNumericTextBox({
            culture: this.props.field.culture,
            format: this.props.field.format,
            decimals: this.props.field.decimals,
            spinners: this.props.field.spinners,
            min: this._min,//this.props.field.min,
            max: this._max,//this.props.field.max,
            value: this._value,
            change: (ev) => {
                this._value = ev.sender.value();
                this.props.onChange(this.props.field, ev.sender.value(), null)
            }
        }).data("kendoNumericTextBox");
        this._numeric.readonly(this._disabled);
        this._numeric.wrapper.attr("data-readonly", this._disabled.toString());
        if (this.props.field.focus)
            this._numeric.focus();

        // Beim fokussieren wird der gesamte Inhalt der TextBox selektiert
        $(this._numericRef).on("focus", function () {
            var input = $(this);
            clearTimeout(input.data("selectTimeId")); //stop started time out if any

            var selectTimeId = setTimeout(function () {
                input.select();
            });

            input.data("selectTimeId", selectTimeId);
        }).blur(function (e) {
            clearTimeout($(this).data("selectTimeId")); //stop started timeout
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this._disabled !== isDisabled) {
            this._disabled = isDisabled;
            this._numeric.readonly(this._disabled);
            this._numeric.wrapper.attr("data-readonly", this._disabled.toString());
        }
        this._checkAndSetMinAndMax(this.props);
        if (this._value !== this.props.value) {
            this._value = this.props.value;
            this._numeric.value(this._value);
        }
    }

    render() {
        let labelUnity = null;

        if (!Helper.isNullOrEmpty(this.props.field.modelUnity) && !Helper.isNullOrEmpty(this.props.handleEval(this.props.field.modelUnity))) {
            labelUnity = (
                <div style={{ width: "100px" }}>
                    <label title={Helper.hasValue(this.props.field.modelUnityTitle) ? this.props.handleEval(this.props.field.modelUnityTitle) : ""}>
                        {this.props.handleEval(this.props.field.modelUnity)}
                    </label>
                </div>
            );
        }

        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1, marginRight: labelUnity == null ? 0 : 10 }} >
                    <input ref={(r) => this._numericRef = r} style={{ width: "100%" }} name={this.props.field.model} required={this.props.required} data-label={this.props.field.name} />
                </div>
                {labelUnity}
            </div>
        );
    }
}
export interface NumericTextBoxProps extends BaseComponentProps {
    field: NumericTextBoxField
    handleEval?(action: string, prepare?: any);
}

export interface NumericTextBoxField extends BaseField {
    min: number;
    max: number;
    spinners: boolean;
    format: string;
    decimals: number;
    modelUnity?: string;
    modelUnityTitle?: string;
    focus?: boolean;
    culture?: string;
}